import { useTranslation } from 'react-i18next';
import { Button } from '../../../../Button/Button';

interface AlertActionProps {
  onClick: () => void;
}

export const CopyToClipboardAction = ({ onClick }: AlertActionProps) => {
  const { t } = useTranslation();

  return (
    <Button type="button" onClick={onClick} variant="text" color="error">
      {t('Move to clipboard')}
    </Button>
  );
};
